import axios from 'axios'
const api = "configurar"

const cedisOperadorLogistico = {
    getCedis: () => axios.get(`${api}/get-cedis`),
    setCedisOperadorLogistico: (idCedis,params) => axios.put(`${api}/${idCedis}/set-operacion`,params),

}
export default cedisOperadorLogistico
